module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: [_vm.center ? 'dof-noticebar-center' : 'dof-noticebar'],
    style: (_vm._px2rem(_vm.noticebarStyle, 75)),
    attrs: {
      "accessible": true,
      "aria-label": _vm.notice,
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.noticeBarClicked($event)
      }
    }
  }, [(_vm._theme == 'colmo') ? _c('midea-apng-view', {
    staticClass: "type-ICON",
    attrs: {
      "src": _vm.typeIcon,
      "loop": true,
      "auto": true
    }
  }) : _c('figure', {
    staticClass: "type-ICON weex-el weex-image",
    staticStyle: {
      "margin-right": "0.21333rem"
    },
    attrs: {
      "src": _vm.typeIcon,
      "data-img-src": _vm.typeIcon,
      "weex-type": "image"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: " weex-el weex-text",
    class: [_vm.center ? 'noticebar-content-center' : 'noticebar-content'],
    style: (_vm._processExclusiveStyle(_vm.contentStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.notice))]), _vm._v(" "), (_vm.mode) ? _c('div', {
    staticClass: "more-click-content weex-ct weex-div",
    attrs: {
      "mode": _vm.mode,
      "weex-type": "div"
    }
  }, [((this.mode == 'btn' && _vm.btnText) || this.mode == 'all') ? _c('p', {
    staticClass: " weex-el weex-text",
    class: ['btnText', _vm.activeBtnText],
    style: (_vm._processExclusiveStyle(_vm.btnTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.noticeIconClicked($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnText))]) : _vm._e(), _vm._v(" "), (this.mode == 'all') ? _c('div', {
    staticClass: " weex-ct weex-div",
    staticStyle: {
      "width": "0.10667rem"
    },
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "closeImg weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm._theme !== 'colmo' && ((_vm.modeIcon && this.mode == 'closable') || this.mode == 'all')) ? _c('figure', {
    staticClass: "mode-ICON weex-el weex-image",
    style: ({
      opacity: _vm._isDiablo ? 0.85 : 1
    }),
    attrs: {
      "src": _vm.modeIcon,
      "data-img-src": _vm.modeIcon,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.closeIconClicked($event)
      }
    }
  }) : (_vm._theme == 'colmo' && ((_vm.modeIcon && this.mode == 'closable') || this.mode == 'all')) ? _c('dof-iconfont', {
    attrs: {
      "code": '\u4725',
      "color": _vm.type == 'important' ? '#E7704C' : 'rgba(255,255,255,0.80)',
      "size": "50"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.modeIcon && this.mode == 'closable') || this.mode == 'all') ? _c('div', {
    staticClass: "closeBox weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.closeIconClicked($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "linkBox weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm._theme !== 'colmo' && _vm.linkIcon && this.mode == 'link') ? _c('figure', {
    staticClass: "mode-ICON weex-el weex-image",
    attrs: {
      "src": _vm.linkIcon,
      "data-img-src": _vm.linkIcon,
      "weex-type": "image"
    }
  }) : (_vm._theme === 'colmo' && _vm.linkIcon && this.mode == 'link') ? _c('dof-iconfont', {
    attrs: {
      "code": '\u4713',
      "color": "rgba(255,255,255,0.80)",
      "size": "50"
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-397a5794", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-397a5794","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-noticebar/index.vue
// module id = 603
// module chunks = 0 1